import { StorageService } from './../../providers/storage.service';
import { SigninPage } from './../signin/signin';
import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { OpenAccountService } from './../../services/openAccount.service';
import { AlertService } from './../../providers/alert.service';
import { AppConfig } from '../../app/app.config';
import * as uuid from "uuid";
import { SysconfigService } from '../../services/sysconfig.service';
import { slideBlockCommon } from '../signin/slide-block/slideBlock';
import { SliderCaptchaPage } from '../signin/slider-captcha/slider-captcha';

// declare let cordova:any;
@Component({
  selector: 'page-register',
  templateUrl: 'regist.html',
  providers: [OpenAccountService]
})
export class RegistPage {

  key = "";
  regform = {
    registerUserName: '',
    registerPassWord: '',
    registerPassWordOK: '',
    registerEmail: '',
    Link: this.key,
    code: '',
    captchaId: ''
  }
  registerForm = this.formBuilder.group({
    'UserName': [this.regform.registerUserName, [Validators.required]],
    'Password': [this.regform.registerPassWord, [Validators.required]],
    'PasswordOK': [this.regform.registerPassWordOK, [Validators.required]],
    'code': [''],
    'Email': [''],
    'Link': [this.key],
  });

  captchaId: string = null;
  captchaSrc: string = null;
  captchaTimer = null;      // 验证码刷新定时器
  sum_count: number = 118;  // 倒计时两分钟
  registerUrl;
  validCodeType;
  isNumCode: boolean = false;
  validateStatus: boolean;
  showZhongWen: boolean = false;
  registerNeedSecurityImage: boolean = false;            // 登录是否显示滑块验证按钮
  registerSecurityImageResult: boolean = false;          // 登录滑块验证验证结果
  registerTextFlag: boolean = false;
  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private openAccountService: OpenAccountService,
    private formBuilder: FormBuilder,
    private storage: StorageService,
    private alert: AlertService,
    private sysconfig: SysconfigService,
    private popoverCtrl: PopoverController,

  ) {
    this.key = this.navParams.data['key'];
  }


  ionViewDidLoad() {
    this.getValidCodeType();
    this.refreshValidateCode();
    // this.getRegister();
  }

  refreshCode() {
    let count = this.sum_count;
    if (!this.captchaTimer) {
      this.captchaTimer = setInterval(() => {
        if (count > 1 && count <= this.sum_count) {
          count--;
        } else {
          clearInterval(this.captchaTimer);
          this.captchaTimer = null;
          this.refreshValidateCode();
        }
      }, 1000)
    }
  }

  //验证码的单击事件
  //TQQ 2017-05-26
  refreshValidateCode() {
    this.captchaId = uuid();
    this.regform.captchaId = this.captchaId;
    this.captchaSrc = AppConfig.GetProdUrl() + '/auth/ValidateCode?id=' + this.captchaId;
    clearInterval(this.captchaTimer);
    this.captchaTimer = null;
    this.refreshCode();
  }

  //检测用户名
  //TQQ 2017-06-16
  checkUserName() {
    if (!this.regform.registerUserName) {
      this.alert.showAlert('用户名不能为空！')
      return false;
    }
    const reg = /^[a-zA-Z][\w]{5,15}$/;
    if (!reg.test(this.regform.registerUserName)) {
      this.alert.showAlert('用户名格式不正确，请输入字母开头，包含英文和数字的6~16个字符！')
      return false;
    }
    this.openAccountService.checkUserName({ userName: this.regform.registerUserName }).then(s => {
      if (!s.Result) {
        this.alert.showAlert("用户名已存在！");
        return false;
      }
    });
    return true;
  }

  //检测密码
  //TQQ 2017-06-16
  checkpassword() {
    if (!this.regform.registerPassWord) {
      this.alert.showAlert('密码不能为空！')
      return false;
    }
    const reg = /^(\w){6,20}$/;
    if (!reg.test(this.regform.registerPassWord)) {
      this.alert.showAlert('密码格式不正确，请输入6-20位字母、数字。')
      return false;
    }
    return true;
  }

  //检测密码ok
  //TQQ 2017-06-16
  checkpasswordok() {
    if (!this.regform.registerPassWordOK) {
      this.alert.showAlert('请重复上面输入的密码', '提示', false);
      return false;
    }
    if (this.regform.registerPassWord != this.regform.registerPassWordOK) {
      this.alert.showAlert('密码不一致，请注意大小写！', '提示', false);
      return false;
    }
    return true;
  }

  //检测邮箱
  //TQQ 2017-06-16
  checkemail() {
    if (!this.regform.registerEmail) {
      return true;
    }
    const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    if (!reg.test(this.regform.registerEmail)) {
      this.alert.showAlert('请填写常用的邮箱例如：ued@163.com！', '提示', false);
      return false;
    }
    return true;
  }

  //检测验证码
  //TQQ 2017-06-16
  checkcode() {
    if (!this.regform.code) {
      this.alert.showAlert('验证码不能为空！', '提示', false);
      return false;
    }
    return true;
  }

  //注册
  //TQQ 2017-06-16
  regitSubmit() {
    if (!this.checkUserName() || !this.checkpassword() || !this.checkpasswordok()) {
      return false;
    }
    this.regform.Link = this.key;
    if (this.showZhongWen && this.validateStatus == false) {
      return this.alert.showAlert('请先进行验证，通过后在注册。')
    }
    if (this.registerNeedSecurityImage && this.registerSecurityImageResult == false) {
      return this.alert.showAlert('请先进行验证，通过后在注册。')
    }
    this.openAccountService.registerUser(this.regform).then(s => {
      if (s.Result) {
        this.alert.showConfirm('注册成功，是否立即登录？', () => {
          this.storage.remove("User");
          this.storage.remove("token");
          this.storage.remove("lotterys");
          this.storage.clear();
          this.navCtrl.push(SigninPage);
        });
      } else {
        this.registerSecurityImageResult = false;
        this.validateStatus = false;
        this.alert.showAlert(s['Error'], '提示', false);

      }
      this.refreshValidateCode();

      // 重置验证码为空
      this.registerForm = this.formBuilder.group({
        'UserName': [this.regform.registerUserName, [Validators.required]],
        'Password': [this.regform.registerPassWord, [Validators.required]],
        'PasswordOK': [this.regform.registerPassWordOK, [Validators.required]],
        'Link': [this.key],
        'code': [''],
        'Email': ['']
      });
    });
  }



  getRegister() {
    this.sysconfig.register().then(res => {
      if (res.Enable) {
        this.registerUrl = res.RegisterUrl;
        if (this.registerUrl.split('/Regist?Key=')[1] == this.key) {
          this.alert.registerAlert('此链接为平台官方注册链接，若您通过本平台代理进行开户注册，将可获得更高的奖金与返点喔！', () => {
          }, '温馨提示');
        }
      }
    })
  }
  /**
 * 验证方式
 * 0是数字校验，1是滑动图片，2是汉字校验
 */
  getValidCodeType() {
    this.sysconfig.getValidCodeType().then(res => {
      if (res.Result) {
        this.validCodeType = res.Error;
        switch (res.Error) {
          case '0':
            this.isNumCode = true;
            break;
          case '1':
            this.registerNeedSecurityImage = true;
            this.registerSecurityImageResult = false;
            break;
          case '2':
            this.showZhongWen = true;
            this.validateStatus = false;
            break;
        }
      }
    })
  }

  /**
* 是否需要滑块验证码
*/
  onRegisterNeedSecurityImage() {
    const popover = this.popoverCtrl.create(slideBlockCommon, {}, { cssClass: "check-captcha-component" }
    );
    popover.present();
    popover.onDidDismiss((data: any) => {
      if (data && data.catchId && data.authSuccess) {
        this.registerSecurityImageResult = data.authSuccess;
        this.regform.captchaId = data.catchId;
      }
    });
  }
  validateStatusChange(val) {
    this.validateStatus = val;
  }

  getCaptchaId(Id) {
    this.regform.captchaId = Id;
  }
  /**
* 中文验证
*/
  onRegisterChineseNeedSecurity() {
    const popover = this.popoverCtrl.create(SliderCaptchaPage, {}, { cssClass: "chinese-need-Security" }
    );
    popover.present();
    popover.onDidDismiss((data: any) => {
      console.log(data);
      if (data) {
        this.validateStatus = data.authSuccess;
        this.regform.captchaId = data.catchId;
        this.regform.code = data.code
      }

    });
  }
}





// WEBPACK FOOTER //
// ./src/pages/regist/regist.ts